export const LocaleLanguageMapping = { 'en-US': 'English', es: 'Spanish' };

export type LocaleType = keyof typeof LocaleLanguageMapping;
